import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { currentStateList } from "../../../../../constants/state";
import { CaptchaPopup, RenderPopup, RenderRequestStatus } from "./components";
export var RenderPopupFormsNewDesign = /*#__PURE__*/memo(function (_ref) {
  var _data$texts$redesignP, _data$texts$redesignP2;
  var renderPopup = _ref.renderPopup,
    closePopup = _ref.closePopup,
    isOpen = _ref.isOpen,
    data = _ref.data,
    isLoading = _ref.isLoading;
  return /*#__PURE__*/React.createElement(React.Fragment, null, renderPopup === currentStateList.success && isOpen && /*#__PURE__*/React.createElement(RenderRequestStatus, {
    isOpen: isOpen,
    onClose: closePopup,
    texts: (_data$texts$redesignP = data.texts.redesignPopupTexts) === null || _data$texts$redesignP === void 0 ? void 0 : _data$texts$redesignP.successPopup,
    "data-t-id": "components-NewDesignComponents"
  }), renderPopup === currentStateList.fail && isOpen && /*#__PURE__*/React.createElement(RenderRequestStatus, {
    isOpen: isOpen,
    onClose: closePopup,
    texts: (_data$texts$redesignP2 = data.texts.redesignPopupTexts) === null || _data$texts$redesignP2 === void 0 ? void 0 : _data$texts$redesignP2.errorPopup
  }), (renderPopup === currentStateList.none || renderPopup === currentStateList.abbreviated) && /*#__PURE__*/React.createElement(RenderPopup, {
    data: data,
    isLoading: isLoading,
    isOpen: isOpen,
    onClose: closePopup
  }), renderPopup === currentStateList.captcha && isOpen && /*#__PURE__*/React.createElement(CaptchaPopup, {
    data: data,
    isLoading: isLoading,
    isOpen: isOpen,
    onClose: closePopup
  }));
});
RenderPopupFormsNewDesign.propTypes = {
  data: PropTypes.shape({}),
  renderPopup: PropTypes.string,
  isOpen: PropTypes.bool,
  closePopup: PropTypes.func,
  isLoading: PropTypes.bool
};